import React from 'react';
import List from './List';

const NewList = ({ ...props }) => (
  <List
    url="installer-orders?order_status=new"
    title="New Orders"
    canAccept={true}
    canView={true}
    {...props}
  />
);

export default NewList;



// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/NewList.js